import script from "./PerformerCompetencies.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformerCompetencies.vue?vue&type=script&setup=true&lang=js"

import "./PerformerCompetencies.vue?vue&type=style&index=0&id=69db3065&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69db3065"]])

export default __exports__